<template>
  <svg
    width="45"
    height="45"
    viewBox="0 0 45 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 22.5C0.5 10.3497 10.3497 0.5 22.5 0.5C34.6503 0.5 44.5 10.3497 44.5 22.5C44.5 34.6503 34.6503 44.5 22.5 44.5C10.3497 44.5 0.5 34.6503 0.5 22.5Z"
      :fill="fill"
      :stroke="stroke"
    />
    <path
      d="M12.6562 21.5938H32.3438C32.8443 21.5938 33.25 21.9995 33.25 22.5C33.25 28.437 28.437 33.25 22.5 33.25C16.563 33.25 11.75 28.437 11.75 22.5C11.75 21.9995 12.1557 21.5938 12.6562 21.5938Z"
      fill="#FFFFFF"
      :stroke="stroke"
    />
    <path
      d="M17.7812 14.0625C17.7812 15.3397 16.7459 16.375 15.4688 16.375C14.1916 16.375 13.1562 15.3397 13.1562 14.0625C13.1562 12.7853 14.1916 11.75 15.4688 11.75C16.7459 11.75 17.7812 12.7853 17.7812 14.0625Z"
      fill="#FFFFFF"
      :stroke="stroke"
    />
    <path
      d="M31.8438 14.0625C31.8438 15.3397 30.8084 16.375 29.5312 16.375C28.2541 16.375 27.2188 15.3397 27.2188 14.0625C27.2188 12.7853 28.2541 11.75 29.5312 11.75C30.8084 11.75 31.8438 12.7853 31.8438 14.0625Z"
      fill="#FFFFFF"
      :stroke="stroke"
    />
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      required: false,
      type: String,
      default: "#5E58BE",
    },
    stroke: {
      required: false,
      type: String,
      default: "#FFFFFF",
    },
  },
};
</script>

<style></style>
